const doc = document
const elements = {
  title: doc.querySelector('.product__title h1'),
  image: doc.querySelector(window.custom_template !== 'foam' ? '#ProductPhotoImg-product-template' : '#customProductPreviewImage'),
  form: doc.querySelector('#AddToCartForm'),
  addButton: doc.querySelector('#AddToCart-product-template'),
  amounts: [...doc.querySelectorAll('.Amount-labels')]
}

export default elements
